/**
 * 新手指引
 */
export default [
  {
    path: '/logmanage',
    name: 'ogmanage',
    component: () => import('@/views/admin/logManage/LogManage.vue'),
    meta: { title: '日志管理' }
  }
]
